import styled from "styled-components";
import { Text } from "@smartsuite/react-ui/lib";

export const ResponseTitle = styled(Text)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
`;
